import Vue from 'vue'
import VueI18n from 'vue-i18n'
import de from './de'
import en from './en'


const numberFormats = {
  'en': {
    'COINS': {
      style: 'decimal'
    },
    'EUR': {
      style: 'currency', currency: 'EUR'
    }
  },
  'de': {
    'COINS': {
      style: 'decimal'
    },
    'EUR': {
      style: 'currency', currency: 'EUR'
    }
  },
}

Vue.use(VueI18n)

function getLocale () {
  return navigator.language.slice(0, 2)
}

export default new VueI18n({
  locale: getLocale(),
  fallbackLocale: 'en',
  silentFallbackWarn: true,
  messages: { en, de },
  silentTranslationWarn: true,
  numberFormats
})
